const mergeRoute = (route: string) => {
  return `${process.env.PUBLIC_URL}${route}`;
};

export const deMergeRoute = (route: string) => {
  const adminSegment = '/admin/';
  const adminIndex = route.indexOf(adminSegment);

  if (adminIndex !== -1) {
    return route.slice(adminIndex + adminSegment.length);
  }

  return route;
};

const ROUTERS_PATHS = {
  BLANK: mergeRoute('/blank'),
  LOGIN: mergeRoute('/login'),
  NOT_FOUND: mergeRoute('/not-found'),
  AUTHORIZATION: mergeRoute('/authorization'),
  DASHBOARD: mergeRoute('/dashboard'),
  TOPIC_DETAIL: mergeRoute('/:categoryUrl/:articleUrl'),
  VERIFY_CODE: mergeRoute('/verify-code'),
  SELECT_PORTAL: mergeRoute('/select-portal'),
  FORGOT_PASSWORD: mergeRoute('/forgot-password'),
  CHANGE_PASSWORD: mergeRoute('/change-password'),
  LESSONS_LEARNT: mergeRoute('/lessons-learnt'),
  PROACTIVE_INITIATIVES: mergeRoute('/proactive-initiatives'),
  PROFILE: mergeRoute('/profile'),
  PROJECTS: mergeRoute('/projects'),
  CONTACTS: mergeRoute('/contacts'),
  SAFETY: mergeRoute('/safety'),
  QUALITY: mergeRoute('/quality'),
  TEMPLATE: mergeRoute('/template'),
  NEWS_CREATE: mergeRoute('/newmergeRoute(s/create'),
  NEWS: mergeRoute('/news'),
  MANAGE_PROJECT_PORTAL: mergeRoute('/manage-project-portal'),
  USERS: mergeRoute('/users'),
  SUBCATEGORIES: mergeRoute('/:slugUrl'),
  TOPIC_MANAGEMENT: mergeRoute('/topic-management'),
  ALL: '/*',

  // ADMIN
  ADMIN: mergeRoute('/admin/*'),
  ADMIN_DASHBOARD: mergeRoute('/admin/dashboard'),
  // CREATE_ARTICLE: mergeRoute('/admin/create-article'),
  CREATE_TOPIC: mergeRoute('/admin/create-topic'),
  CREATE_CATEGORY: mergeRoute('/admin/create-category'),
  CREATE_SUBCATEGORY: mergeRoute('/admin/create-sub-category'),
  EMAIL_TEMPLATE: mergeRoute('/admin/email-template'),
  ROLE: mergeRoute('/admin/role'),
  USER: mergeRoute('/admin/users'),
  FEEDBACK: mergeRoute('/admin/feedback'),
  REVIEW: mergeRoute('/admin/reviews'),
  ANALYTICS: mergeRoute('/admin/analytics'),
  EDIT_REVIEW: mergeRoute('/admin/edit-review'),
  ADVANCED_SEARCH: mergeRoute('/admin/advanced-search')
};

export default ROUTERS_PATHS;
